import {Application, Container, Point} from 'pixi.js';

import {IAsyncRenderer, IDimensions} from '@specials/gcs-engine';

import {HTMLElementId} from '../constants';

export class PixiRenderer implements IAsyncRenderer<Container> {
  public app: Application | null;
  public rootContainer: Container;
  public containerNode: HTMLElement;

  constructor() {
    this.app = null;
  }

  public async create(containerNode: HTMLElement): Promise<void> {
    this.containerNode = containerNode;
    const {width, height} = containerNode.getBoundingClientRect();

    this.app = new Application();
    await this.app.init({
      preference: 'webgl',
      width,
      height,
      background: 0x000000,
      resolution: this.getAppDPR(),
      autoDensity: true,
      autoStart: false,
      antialias: true,
      resizeTo: this.containerNode,
    });

    this.app.ticker.autoStart = false;

    const canvas = this.app.canvas as HTMLCanvasElement;
    containerNode.appendChild(canvas);
    canvas.id = HTMLElementId.GameCanvas;
    canvas.style.overflow = 'hidden';

    // это нужно для локального использования браузерного расширения для пикси
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (globalThis as any).__PIXI_APP__ = this.app;

    this.rootContainer = new Container();
    this.app.stage.addChild(this.rootContainer);
  }

  public getAppDPR(): number {
    return window.devicePixelRatio;
  }

  public getFrameDimensions(): IDimensions {
    if (!this.app) return {width: 0, height: 0};

    return {
      width: this.app.renderer.width,
      height: this.app.renderer.height,
    };
  }

  public getCenter(): Point {
    const dimensions = this.getFrameDimensions();
    return new Point(dimensions.width / 2, dimensions.height / 2);
  }

  public stop(): void {
    this.app?.stop();
  }

  public start(): void {
    this.app?.start();
  }

  public pause(): void {
    if (this.app) {
      this.app.stop();
      this.app.stage.eventMode = 'none';
    }
  }

  public resume(): void {
    if (this.app) {
      this.app.start();
      this.app.stage.eventMode = 'auto';
    }
  }

  public destroy(): void {
    if (this.app) {
      this.app.destroy();
      this.app = null;
    }
  }
}
